import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-schemes-form',
  templateUrl: './schemes-form.component.html',
  styleUrls: ['./schemes-form.component.css']
})
export class SchemesFormComponent implements OnInit {

  title="Add CaseType";
  data : any = {};
  formInvalid : boolean = false;
  s : any = {};
  Sch_Id : number;
  mode : string;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datePipe:DatePipe) 
  { }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.Sch_Id = params['Sch_Id'];  
      this.mode  =   params['mode'];
      
      if(this.Sch_Id > 0){
        this.GetSchemeById(this.Sch_Id)
      }    
  });
  
  if(this.mode=='view'){
    this.title = "View Scheme Proceedings";
  }
  else if(this.mode=='edit'){
    this.title = "Edit Scheme Proceedings";
  }  
  }


  SaveScheme(Scheme: NgForm){    
    debugger
    
    if(Scheme.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }  
   

    else{   
                                  
            this.data = this.userService.PostScheme(Scheme.value);    
            this.data.subscribe(
            (response) => {
              Scheme.reset();
              Scheme.resetForm();
              Scheme.form.markAsPristine();
              Scheme.form.markAsUntouched();        
              swal('Success!', 'Scheme Added Successfully .', 'success');
              this.router.navigate(['/home/schemes-master']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetSchemeById(Sch_Id){
    debugger
    
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetByIdScheme(Sch_Id);
        this.data.subscribe(
          (response: any) => {
            this.s = response;        
            
            // if (this.ap.AP_Date != null)
            //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
            // if (this.ap.AP_Date != null)
            //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
            console.log("getbyid");console.log(response);
    
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
  }
  UpdateScheme(Scheme: NgForm) { 
       
    this.data = this.userService.UpdateScheme(Scheme.value,this.Sch_Id);
   this.data.subscribe(
     (response) => {
      Scheme.reset();
      Scheme.resetForm();
      Scheme.form.markAsPristine();
      Scheme.form.markAsUntouched();           
                   
       swal('Success!', 'Scheme updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/schemes-master']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
  //this.router.navigate(['/home/district']) ; 
  this.s.Sch_Name='';
  this.s.Sch_Code='';
}




  

}




// WEBPACK FOOTER //
// ./src/app/master/schemes/schemes-form/schemes-form.component.ts